import { render } from "./SocialCategory.vue?vue&type=template&id=51afc12c"
import script from "./SocialCategory.vue?vue&type=script&lang=js"
export * from "./SocialCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__